import React from 'react';

import HeadMeta from '@/components/static-pages/HeadMeta';
import LocalityDirectoryTemplate from '@/components/templates/LocalityDirectoryTemplate';
import getPageData from '@/services/getPageData.js';

export async function getServerSideProps({ req, res, query }) {
  const { metadata, fallback } = await getPageData({ req, res, query });

  return {
    props: {
      canonicalUrl: metadata.canonical_url,
      content: metadata.content,
      seoDescription: metadata.seo_description,
      seoTitle: metadata.seo_title,
      // TODO: Fidel to add 'general' links section to `sections` in Seeker
      sections: [{ ...metadata?.sections?.[0], general: temporaryStaticGeneralSection }],
      title: metadata.title,
      noindex: !!fallback,
    },
  };
}

const LocalityDirectory = ({
  canonicalUrl,
  content,
  seoDescription,
  seoTitle,
  sections,
  title,
  noindex,
}) => (
  <React.Fragment>
    <HeadMeta
      title={seoTitle}
      description={seoDescription}
      canonicalUrl={canonicalUrl}
      noindex={noindex}
    />
    <LocalityDirectoryTemplate content={content} sections={sections} title={title} />
  </React.Fragment>
);

// TODO: Fidel to add 'general' links section to `sections` in Seeker
const temporaryStaticGeneralSection = [
  { title: 'RV Rental Locations', url: 'https://www.outdoorsy.com/rv-info/rv-rental-locations' },
  { title: 'Camper Van Rental', url: 'https://www.outdoorsy.com/rv-info/camper-van-rental' },
  { title: 'RV America', url: 'https://www.outdoorsy.com/rv-info/rv-america' },
  {
    title: 'Pop Up Tent Trailer Rental',
    url: 'https://www.outdoorsy.com/rv-info/pop-up-tent-trailer-rental',
  },
  { title: 'Trailer for Rent', url: 'https://www.outdoorsy.com/rv-info/trailers-for-rent' },
  {
    title: 'Camper Trailer Rental',
    url: 'https://www.outdoorsy.com/rv-info/camper-trailer-rental',
  },
  {
    title: 'Conversion Van Rental',
    url: 'https://www.outdoorsy.com/rv-info/conversion-van-rental',
  },
  { title: 'RV Rental Prices', url: 'https://www.outdoorsy.com/rv-info/rv-rental-prices' },
  { title: 'RV For Rent By Owner', url: 'https://www.outdoorsy.com/rv-info/rv-for-rent-by-owner' },
  { title: 'Campers For Rent', url: 'https://www.outdoorsy.com/rv-info/campers-for-rent' },
  { title: 'Small RV Rental', url: 'https://www.outdoorsy.com/rv-info/small-rv-rental' },
  {
    title: 'RV Rental Prices Average',
    url: 'https://www.outdoorsy.com/rv-info/rv-rental-prices-average',
  },
  { title: 'Long Term RV Rental', url: 'https://www.outdoorsy.com/rv-info/long-term-rv-rental' },
  { title: 'Airstream RV Rental', url: 'https://www.outdoorsy.com/rv-info/airstream-rv-rental' },
  { title: 'Class B RV Rental', url: 'https://www.outdoorsy.com/rv-info/class-b-rv-rental' },
  {
    title: 'Fifth-Wheel Truck Rental',
    url: 'https://www.outdoorsy.com/rv-info/5th-wheel-truck-rental',
  },
  { title: 'RV Trailer Rental', url: 'https://www.outdoorsy.com/rv-info/rv-trailer-rental' },
  { title: 'Class A RV Rentals', url: 'https://www.outdoorsy.com/rv-info/class-a-rv-rental' },
  {
    title: 'Travel Trailer Rental',
    url: 'https://www.outdoorsy.com/rv-info/travel-trailer-rental',
  },
];

LocalityDirectory.header = { preset: 'locality' };

export default LocalityDirectory;
